"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerPhase = exports.uiStatus = exports.ProcessRunType = exports.ProcessStatus = exports.CaseArtifactTypes = exports.ResourceTypes = void 0;
var ProcessStatus;
(function (ProcessStatus) {
    ProcessStatus["PROCESS_CREATED"] = "Process Created";
    ProcessStatus["WAITING_FOR_DATA"] = "Waiting for data";
    ProcessStatus["DATA_COLLECTED"] = "Data Collected";
    ProcessStatus["PREDICTION_IN_PROGRESS"] = "Prediction in Progress";
    ProcessStatus["PREDICTED"] = "Predicted";
    ProcessStatus["MANUAL"] = "Manual";
    ProcessStatus["AT_CODER"] = "At Coder";
    ProcessStatus["DONE"] = "Done";
    ProcessStatus["ERROR"] = "Error";
})(ProcessStatus || (ProcessStatus = {}));
exports.ProcessStatus = ProcessStatus;
var uiStatus;
(function (uiStatus) {
    uiStatus["IN_PROGRESS"] = "In Progress";
    uiStatus["WAITING"] = "Waiting For Coder";
    uiStatus["MANUAL"] = "Manual";
    uiStatus["DORMANT"] = "Dormant";
    uiStatus["CANCELLED"] = "Cancelled";
    uiStatus["AUTOMATED"] = "Automated";
    uiStatus["UPDATED_MANUAL"] = "Updated - Manual";
})(uiStatus || (uiStatus = {}));
exports.uiStatus = uiStatus;
var ProcessRunType;
(function (ProcessRunType) {
    ProcessRunType["MANUAL"] = "MANUAL";
    ProcessRunType["PREDICTION"] = "PREDICTION";
    ProcessRunType["SOURCE"] = "SOURCE";
    ProcessRunType["CQA"] = "CQA";
})(ProcessRunType || (ProcessRunType = {}));
exports.ProcessRunType = ProcessRunType;
var CaseArtifactTypes;
(function (CaseArtifactTypes) {
    CaseArtifactTypes["ASSEMBLED"] = "ASSEMBLED";
    CaseArtifactTypes["MAPPED"] = "MAPPED";
    CaseArtifactTypes["CLINICAL"] = "CLINICAL";
    CaseArtifactTypes["PREDICTION"] = "PREDICTION";
    CaseArtifactTypes["PROCESSED"] = "PROCESSED";
    CaseArtifactTypes["SUBMITTED"] = "SUBMITTED";
    CaseArtifactTypes["CLAIM"] = "CLAIM";
    CaseArtifactTypes["REMITTANCE"] = "REMITTANCE";
    CaseArtifactTypes["REFERRAL"] = "REFERRAL";
    CaseArtifactTypes["CODED"] = "CODED";
})(CaseArtifactTypes || (CaseArtifactTypes = {}));
exports.CaseArtifactTypes = CaseArtifactTypes;
var CustomerPhase;
(function (CustomerPhase) {
    CustomerPhase["TESTING"] = "TESTING";
    CustomerPhase["PARALLEL"] = "PARALLEL";
    CustomerPhase["ACTIVE"] = "ACTIVE";
    CustomerPhase["LIVE"] = "LIVE";
    CustomerPhase["PRODUCTION"] = "PRODUCTION";
})(CustomerPhase || (CustomerPhase = {}));
exports.CustomerPhase = CustomerPhase;
var ResourceTypes;
(function (ResourceTypes) {
    ResourceTypes["UI"] = "ui";
})(ResourceTypes || (ResourceTypes = {}));
exports.ResourceTypes = ResourceTypes;
//# sourceMappingURL=enums.js.map